module.exports = __webpack_public_path__ + "img/hr-sand-decal-19.82fb3338.png";